<template>
  <div
    class="h-100 w-100 d-flex align-items-center omnisearch"
  >
    <t-input
      v-model="query"
      @keydown.native.esc="cancel"
      placeholder="Search for something"
      class="w-100"
    >
      <template v-slot:prefix>
        <icon
          style="top: 6px;right: 13px;color: #c0c4cc;"
          icon="search"
        />
      </template>
    </t-input>
    <div
      v-if="isDropdownActive"
      class="border omnisearch__results"
    >
      <div class="row">
        <search-section
          large
          name="Articles"
          :results="articles.map(article => ({
            ...article,
            id: article.id.split('/')[1] || ''
          }))"
          name-key="title"
          param="articleId"
          link="articles.view"
          :max="3"
        />


        <search-section
          name="Accounts"
          :results="accounts"
          param="accountId"
          link="accounts.view"
        />


        <search-section
          name="Users"
          :results="users"
          param="userId"
          link="users.view"
          :large="onlyUsers"
        />


        <search-section
          name="Companies"
          :results="companies"
          param="companyId"
          link="companies.view"
        />


        <search-section
          name="Analysts"
          :results="analysts"
          param="analystId"
          link="analysts.view"
        />


        <search-section
          name="Channels"
          :results="channels"
          param="channelId"
          id-key="objectID"
          link="channels.view"
        />
      </div>

      <div class="d-flex justify-content-center omnisearch__results__btn">
        <button
          class="w-100 btn  btn-primary"
          @mousedown.prevent
          @click="showResults"
        >
          <span>View all results</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import SearchSection from './Section'
import {debounce} from '@/helpers'
import {mapState, mapActions} from 'vuex'

export default {
  components: {
    SearchSection,
  },

  computed: {
    ...mapState({
      articles: (state) => state.search.articles,
      accounts: (state) => state.search.accounts,
      subscriptions: (state) => state.search.subscriptions,
      users: (state) => state.search.users,
      companies: (state) => state.search.companies,
      analysts: (state) => state.search.analysts,
      channels: (state) => state.search.channels,
    }),

    onlyUsers () {
      const {
        articles = [],
        accounts = [],
        subscriptions = [],
        companies = [],
        analysts = [],
        channels = [],
      } = this

      return (
        articles.length +
        accounts.length +
        subscriptions.length +
        companies.length +
        analysts.length +
        channels.length === 0
      )
    },
  },


  data () {
    return {
      query: '',
      isDropdownActive: false,
    }
  },

  mounted () {
    router.afterEach(() => {
      this.isDropdownActive = false
    })
  },

  watch: {
    isDropdownActive (val) {
      if (!val) {
        this.query = null
      }
    },

    query (query) {
      if (query) {
        this.performSearch(query)
        console.log('hi')
        this.isDropdownActive = true
      }
    },
  },

  methods: {
    performSearch: debounce(function(query) {
      this.search(query)
    }, 300),
    ...mapActions('search', [
      'search',
    ]),
    cancel () {
      this.query = null
      this.isDropdownActive = false
    },
    mouseclick (e) {
      if (this.isDropdownActive) {
        this.isDropdownActive = e.path.indexOf(this.$el) !== -1
      }
    },

    showResults () {
      this.$router.push({name: 'search', query: {q: this.query}})
      this.isDropdownActive = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.omnisearch {
  z-index: 999;
  position: relative;

  .input {
    border: 0;
  }

  &__results {
    position: absolute;
    top: 100%;
    left: 0;
    width: 564px;
    padding: 24px;
    z-index: 2;
    background: #FBFBFB;

    &__section {
      margin-bottom: 24px;
      display: flex;
      flex-direction: column;

      &__header {
        margin-bottom: 0.5rem;
        font-size: 14px;
        color: $primary;
        text-transform: uppercase;
        letter-spacing: 1.2px;
        font-weight: bold;
      }

      .omnisearch-result {
        font-size: 16px;
        letter-spacing: 0.28px;
        line-height: 2;
        a {
          color: #58666e;
        }
      }
    }

    &__btn {
      .btn {
        height: 3rem;
      }
    }

    @media(max-width: 576px) {
      width: 100%;
      height: calc(100vh - 120px);
      padding: 1rem;

      .row {
        overflow-y: auto;
        height: calc(100% - 3rem);
      }
    }
  }
}
</style>
